import { normalizePostTags } from './normalizePostTags';

export const ARCHIVED_TAG = 'archived';

export function isPostArchived(post: { tags?: string[] | null }): boolean {
  return normalizePostTags(post.tags).some(
    (t) => t.toLowerCase().replace(/^#/, '') === ARCHIVED_TAG
  );
}

export function filterVisiblePosts<T extends { tags?: string[] | null }>(posts: T[]): T[] {
  return posts.filter((p) => !isPostArchived(p));
}
